import EventBus from "./event-bus";

const axios = require('axios');

export function userSignIn(email, password) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'user/signIn?email=' + email + '&password=' + password;
    axios.post(url)
      .then(function (response) {
        EventBus.$emit("showLoading", false);
        let data = response.data;
        resolve(data);
        if(data.success == true) {
          console.log("now call auth setUser");
          // auth.setUser();
        }
      })
      .catch(function (err) {
        EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}

export function setChangedPassword(password){
  let apiPath = `${process.env.ROOT_API}password/change`
  let data = {
    password: password
  }

  return new Promise(function(resolve, reject) {
    axios.post(
      apiPath,
      JSON.stringify(data),
      {headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
        }
      }
    )
      .then(function(response) {
        resolve(response)
      })
      .catch(error=>{
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error)
      });
  })
}

export function verifyToSetPassword(token, password){
  let apiPath = `${process.env.ROOT_API}password/verify`
  let data = {
    token: token,
    password: password
  }
  return new Promise(function(resolve, reject) {
    axios.post(
      apiPath,
      JSON.stringify(data),
      {headers: {"Content-Type": "application/json"}}
    )
      .then(function(response) {
        resolve(response.data);
      })
      .catch(error=>{
        console.log("error");
        if(error.response != undefined) {
          console.log(error.response);
        }
        reject(error)
      });
  })
}

export function sendVerificationToken(url, email) {
  let apiPath = `${process.env.ROOT_API}password/forgot`
  let data = {
    email: email,
    url: url
  }
  return new Promise(function(resolve, reject) {
    axios.post(
        apiPath,
        JSON.stringify(data),
        {headers: {"Content-Type": "application/json"}}
      )
      .then(function(response) {
        resolve(response.data)
      })
      .catch(error=>{
        reject(error)
      });
  })
}

export function getUserByToken() {
  return new Promise(function(resolve, reject) {
    // console.log("getUserByToken")
    axios.get(process.env.ROOT_API + 'user/me')
      .then(response => {
        // console.log(response)

        if(response.data === '') {
          EventBus.$emit("sessionExpired");
          return;
        }
        resolve(response.data)
        if(response.data != undefined && response.data != null && response.data.merchantId != undefined) {

          auth.setAccount(response.data);
          if(response.data.type === 'ROLE_DRIVER') {
            EventBus.$emit("setUserType", 'driver');
          } else if(response.data.type === 'ROLE_MERCHANT') {
            EventBus.$emit("setUserType", 'merchant');
            subscribeFCMTopic('merchant-' + response.data.merchantId);
          } else if(response.data.type === 'ROLE_ADMIN' || response.data.type === 'ROLE_MANAGER') {
            EventBus.$emit("setUserType", 'admin');
          }

        }
      })
      .catch((error) => {
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        //reject()
      });
  })
}



/**
 * Create users at one go
 * @param user
 * @returns {Promise<unknown>}
 */
export function updateUser(user) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/user', JSON.stringify(user), {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function (response) {
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        reject(error)
      });
  })
}

export function updateRiderInfo(query) {
  let address = process.env.ROOT_API + 'rider/availability?' + query;
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios({
      method:'post',
      url:address,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })

      .then(function (response) {
        EventBus.$emit("showLoading", false);
        let data = response['data'];
        console.log("Update USER");
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        reject(error)
      });
  })
}


export function getMyMerchant() {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'merchant/merchant', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("logon", false);
        }
        //reject()
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js